import {DefaultViewAsState} from '../constants/DefaultViewAsState'
import {writeViewAsStateToStorage} from './writeViewAsStateToStorage'

export function endViewAsPreviewLocally(): void {
  writeViewAsStateToStorage({...DefaultViewAsState})
  window.location.reload()
}
